import React from "react";
import { Link } from "react-router-dom";
import { PRODUCT } from "../mock";
import ContactForm from "./ContactForm";
import NewsletterForm from "./NewsletterForm";

const Footer = () => {
  const cols = [
    {
      title: "Shop",
      links: [
        { label: "Red Light Mask", to: `/products/${PRODUCT.handle}` },
      ],
    },
    {
      title: "Help",
      links: [
        { label: "Contact Us", to: "/contact" },
        { label: "FAQ", to: "/#faq" },
      ],
    },
    {
      title: "Company",
      links: [
        { label: "Our Story", to: "/#" },
        { label: "Journal", to: "/blog" },
        { label: "Reviews", to: `/products/${PRODUCT.handle}` },
      ],
    },
  ];

  return (
    <footer className="bg-[#1A1A1A] text-[#F4EFE8]">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 pt-16 pb-10">
        {/* CONTACT */}
        <div id="contact" className="grid md:grid-cols-2 gap-10 md:gap-16 pb-14 mb-14 border-b border-[#F4EFE8]/15">
          <div>
            <p className="text-[12px] tracking-[0.3em] uppercase text-[#F4EFE8]/50 mb-4">Get In Touch</p>
            <h3 className="font-serif-display text-[32px] md:text-[40px] font-medium leading-tight mb-4">
              Questions? Our dermatologist-backed team is here.
            </h3>
            <p className="text-[14px] text-[#F4EFE8]/60 leading-relaxed max-w-md">
              Reach out any time and we'll get back to you shortly. You can also email us directly at{" "}
              <a href="mailto:team@flowlux.co" className="underline underline-offset-4 text-[#F4EFE8]">team@flowlux.co</a>.
            </p>
          </div>
          <ContactForm />
        </div>

        <div className="grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 md:gap-8">
          <div>
            <span className="font-serif-display font-bold text-[30px] md:text-[36px] tracking-[0.24em] text-white pl-[0.24em] inline-block mb-5">
              FLOWLUX
            </span>
            <p className="text-[#F4EFE8]/60 text-sm leading-relaxed max-w-xs">
              Thoughtfully designed wellness essentials for deep rest, recovery, and modern living.
            </p>
            <p className="text-[11px] tracking-[0.2em] uppercase text-[#F4EFE8]/70 mt-6 mb-3">Join for exclusive offers</p>
            <NewsletterForm />
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-[12px] tracking-[0.2em] uppercase mb-5 text-[#F4EFE8]/90">{c.title}</h4>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-[#F4EFE8]/55 hover:text-[#F4EFE8] transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-6 border-t border-[#F4EFE8]/15 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[11px] tracking-[0.12em] text-[#F4EFE8]/45 uppercase">
            &copy; {new Date().getFullYear()} FLOWLUX. All rights reserved.
          </p>
          <div className="flex gap-6 text-[11px] tracking-[0.12em] text-[#F4EFE8]/45 uppercase">
            <Link to="/privacy" className="hover:text-[#F4EFE8]">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#F4EFE8]">Terms of Service</Link>
            <Link to="/terms" className="hover:text-[#F4EFE8]">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
